// en

import bi from './bi';
import mka from './mka';
import segment from './segment';
import component from './component';
import communication from './communication';
import authentication from './authentication';
import myAccount from './my-account';
import notification from './notification';
import permission from './permission';
import dataRelation from './data-relation';
import dataConnector from './data_connector';
import exportReport from './export';
import datepicker from './datepicker';
import customerInsight from './customer-insight';

export default {
  noti_exporter_account: 'Notification Sender Account',
  noti_category: 'Category',
  noti_coupon_all: 'Receive notifications from important events in all coupon categories',
  noti_credit_all: 'Receive notifications from important events in all credit categories',
  noti_campaign_all: 'Receive notifications from important events in all campaign categories',
  coupon_dynamic: 'Unable to turn on notifications',
  coupon_dynamic_detail: 'Notifications are not available for this type of fixed-format coupon.',
  coupon_low: 'Coupons Running Low',
  coupon_low_des: 'Notify when the coupon balance falls below the defined threshold.',
  coupon_remaining: 'Remaining Coupon',
  coupon_remaining_des: 'จำนวนคูปองคงเหลือ',
  coupon_expiring: 'Coupons Near Expiry',
  coupon_expiring_des: 'แจ้งเตือนเมื่อแคมเปญคูปองถึงวันที่ใกล้สิ้นสุดตามที่กำหนด',
  notify_within: 'Notify Within',
  credit_low: 'Credits Running Low',
  credit_low_des: 'Notify when remaining credit drops below the set limit.',
  credit_empty: 'เครดิตหมด',
  credit_empty_des: 'แจ้งเตือนเมื่อเครดิตไม่เพียงพอสำหรับส่งออกแคมเปญการสื่อสารได้',
  credit_remaining: 'Remaining Credit',
  credit_topup: 'Credit Top-Up Successful',
  credit_topup_des: 'Notify when credit has been successfully added to the ChocoCDP system.',
  campaign_low: 'Campaigns Ending Soon',
  campaign_low_des: 'Notify when a campaign is nearing its scheduled end date.',
  campaign_end: 'Campaign Ended',
  campaign_end_des: 'Notify when a marketing automation campaign has officially ended.',
  campaign_remaining: 'Remaining Campaign',
  campaign_time: 'เวลาส่งออกแจ้งเตือน',
  add_contact: 'Add Contact',
  add_username: 'Add the username of the person who should receive notifications from the ChocoCDP system',
  username: 'Username',
  noti_contact: 'Contact List',
  noti_contact_detail: 'A list of all users eligible to receive notifications from the ChocoCDP system.',
  move_segment: 'Move Segment',
  color_swatches: 'Color Swatches',
  simple: 'Simple',
  custom: 'Custom',
  advance: 'Advance',
  shade: 'Shade',
  random: 'Random',
  clear_all: 'Clear All',
  coupon: 'Coupon',
  credit: 'Credit',
  campaign: 'Campaign',
  coupon_des: 'Set conditions for sending notifications related to coupon usage.',
  credit_des: 'Set conditions for sending notifications related to credit usage and balance.',
  campaign_des: 'Set conditions for sending notifications related to automated marketing campaign',
  all: 'All',
  mb: 'MB',
  email: 'Email',
  sms: 'SMS',
  noti_add_user: 'Add Contact',
  noti_add_user_detail: 'Add users who should receive notifications from the ChocoCDP system',
  confilm_delete_title: 'Confirm Delete',
  confilm_delete_detail: 'Do you want to delete {fullname} ?',
  cancel: 'Cancel',
  next: 'Next',
  add: 'Add',
  confirm: 'Confirm',
  notification_setting: 'Notification Setting',
  notification_des_setting: 'Set up personal notifications to receive automatic messages for key events in coupons, credits, and campaigns.',
  setting_noti: 'Notification Setting',
  advanced_setting: 'Advanced Setting',
  unit: 'Units',
  day: 'day(s)',
  time_picker: {
    select_time: 'Select Time',
  },

  date_picker: {
    relative: {
      // -- duration
      day: '{days} Day | {days} Days',
      month: '{months} Month | {months} Months',
      year: '{years} Year | {years} Years',
      hour: '{hours} Hour | {hours} Hours',
      minute: '{minutes} Minute | {minutes} Minutes',
      second: '{seconds} Second | {seconds} Seconds',
      // --- relative
      today: 'Today',
      // --- custom
      custom: 'Custom',
    },
    to: 'To',
    date_range: 'Date Range',
    select_date: 'Select Date',
    start_date: 'Start Date',
    end_date: 'End Date',
    apply: 'Apply',
    cancel: 'Cancel',
    relative_picker: 'Relative Picker',
    last_day: 'Last {num} Days',
    last_month: 'Last {num} Months',
    last_year: 'Last {num} Years',
    last_hour: 'Last {num} Hours',
    last_minute: 'Last {num} Minutes',
    last_second: 'Last {num} Seconds',
  },
  Detail: 'Detail',
  Segment: 'Segment',
  Template: 'Template',
  Communication: 'Communication',
  Channel: 'Channel',
  'Line OA': 'LINE',
  Campaign: 'Campaign',
  campaign_list: 'Campaign List',
  edit_campaign: 'Edit Campaign',
  Create: 'Create',
  campaign_info: 'Campaign Info',

  auth: {
    btn_login: 'login',
    username: 'username',
    email_required: 'email is required',
    username_required: 'username is required',
    username_invalid: 'username is invalid',
    password: 'password',
    password_required: 'password is required',
    password_invalid: 'password is invalid',
  },

  main_menu: {
    dashboard: 'Dashboard',
    segment: 'Segment',
    data_connector: 'Data Connector',
    data_cconnector_overview: 'Data Source',
    data_connector_data_relationship: 'Data Relationship',
    data_connector_coupon: 'Coupon',
    data_connector_history: 'History',
    communication: 'Communication',
    communication_all_channel: 'All Channel',
    communication_limitation: 'Limitation',
    automation: 'Marketing Automation',
    setting: 'Setting',
  },

  menu_bar: {
    edit_profile: 'Edit Profile',
    brand_account: 'Brand Account',
    change_brand_account: 'Change Brand Account',
    permission: 'Permission',
    profile: 'Profile',
    manage_permission: 'Manage Permission',
    history: 'History',
    change_role: 'Change Role',
    manage_storage: 'Manage Storage',
    configuration: 'Configuration',
    sign_out: 'Sign Out',
    change_password: 'Change Password',
    switchlanguage: 'Language',
    setting_notification: 'Notification Setting',
  },

  change_brand_modal: {
    error: 'Something went wrong',
    error_description: 'Brand cannot be selected at this time',
    change_brand_account: 'Change Brand Account',
    select_brand_account: 'Select Brand Account',
    cancel: 'Cancel',
    change: 'Change',
  },

  bi,

  data_connector: {
    // Tab
    tab_data_connector: 'Data Connector',
    tab_data_source_list: 'Data Link',
    tab_add_datasource: 'Add Data Source',
    tab_excel_datasource: 'Excel Data Source',
    tab_file_history: 'Excel File History',
    tab_Setting_fasthelp5_Integration: 'Setting fasthelp5 Integration',
    // Page overview
    overview_title: 'The Management tools for data import and export.',
    overview_btn_connect_datasource: 'Data Source',
    overview_data_connector_detail: 'You can now connect the data sources you want to send data to.',
    overview_btn_connect_commu: 'Destination',
    overview_commu_detail: 'Now you can connect the Destinations your want to send data to.',
    // Page file history
    file_history_column_no: 'No.',
    file_history_column_ref_code: 'Ref.Code',
    file_history_column_type: 'Template Type',
    file_history_column_name: 'Name',
    file_history_column_amount: 'Upload File',
    file_history_column_last_update: 'Last Update',
    file_history_column_status: 'Status',
    // Page datasource
    datasource_header: 'Add Data Source',
    datasource_search_text: 'search',
    // Page dataset
    dataset_btn_create_template: 'Create',
    // Page create template
    // Page update file
    upload_file_progress_upload: 'Upload File',
    upload_file_progress_confirm_data: 'Confirm Data',
    upload_title_download_template: 'Download Template',
    upload_btn_download_template: 'Download Template',
    upload_btn_browse_file: 'Browse File',
    upload_backup_file: 'Backup file',
    // Page summary upload
    summary_upload_column_status: 'Status',
    summary_upload_column_quantity: 'Quantity',
    summary_upload_column_row_success: 'Success',
    summary_upload_column_row_error: 'Error',
    summary_upload_column_row_total: 'All',
    // Page coupon managements
    tab_coupon_management: 'Coupon',
    tab_coupon_detail: 'Detail',
    upload_coupon_button: 'Upload Coupon',
    edit_coupon_button: 'Edit Detail',
    status_coupon_text: 'Status',
    uploading: 'Uploading',
    upload_failed: 'Upload Failed',
    retry: 'Click to retry',
    // Table coupon
    couponId: 'Coupon Id',
    image: 'Image',
    campaignName: 'Campaign Name',
    couponType: 'Coupon Type',
    trackingCode: 'Tracking Code',
    source: 'Source',
    format: 'Format',
    balanceandtotal: 'Balance/Total',
    balance: 'Balance',
    total: 'Total',
    reference: 'Reference',
    lastUpload: 'Last Upload',
    updateBy: 'Update by',
    status: 'Status',
    lastUpdate: 'Last Update',
    action_edit: 'action edit',
  },

  setting: {
    unauthorized: 'Unauthorized',
    detail_setting: '"You need permission to perform this action" on Choco CDP.',
    cell_us: 'Cell us',
    contact: 'Contact',
  },

  base_table: {
    noItems: 'No Items',
    loading: 'Loading',
  },
  global: {
    view_more: 'View More',
    loading: 'Loading...',
    export: 'Export',
    cancel: 'Cancel',
    apply: 'Apply',
    close: 'Close',
    confirm: 'Confirm',
    filter: 'Filter',
    save: 'Save',
    save_as: 'Save As',
    edit: 'Edit',
    copy: 'Copy',
    delete: 'Delete',
    try: 'Try Again',
    no_information: 'No information',
    error: 'An error occurred.',
    back: 'Back',
    not_dowload_report: "Don't Download Report",
    confirm_delete: 'Confirm Delete',
    do_confirm_delete: 'Do you want delete {any}',
    confirm_duplicate: 'Confirm Duplicate',
    do_confirm_duplicate: 'Do you want duplicate {any}',
    confirm_cancel: 'Confirm Cancel',
    do_confirm_cancel: 'Do you want Cancel {any}',
    successful: 'Successful',
  },

  component: component,
  segment: segment,
  mka: mka,
  communication: communication,
  authentication: authentication,
  account: myAccount,
  notification: notification,
  permission: permission,
  dataRelation: dataRelation,
  dc: dataConnector,
  exportReport: exportReport,
  // Churn Rate​
  churn_rate: 'Churn Rate​',
  all_segment: 'All Segment​',
  overview: 'Overview​',
  data_source: 'Data Source​',
  calculate_churn_rate: 'calculate Churn Rate​​',
  overall_churn_rate: 'Overall Churn Rate',
  des_overall_churn_rate:
    'Customer churn rate is the proportion of total customers who cease using a company products or services within a specified time frame.',
  select_segment: 'Select Segment',
  stage: 'Stage',
  normal: 'Normal',
  risk_churn: 'Risk Churn',
  churn: 'Churn',
  close: 'Close',
  // Line Card type
  select_card_type: 'Select Card Type',
  products: 'Products',
  places: 'Places',
  people: 'People',
  pictures: 'Pictures',
  summary: 'Summary',
  page: 'Page',
  type: 'Type',

  number_of_images: 'Number of Images',
  upload_image: 'Upload image',
  enter_label_text: 'Enter label text',
  header: 'Header',
  enter_header: 'Enter header',
  description: 'Description',
  enter_description: 'Enter description',
  price: 'Price',
  call_to_action: 'Call to action',
  enter_action: 'Enter action',
  enter_action_label: 'Enter action label',
  address: 'Address',
  enter_address_info: 'Enter address info',
  enter_name: 'Enter Name',
  name: 'Name',
  additional: 'Additional info',
  enter_additional_type: 'Select',
  additional_info: 'Enter info details',
  hours: 'Hours',
  opening_hours: 'Opening Hours',
  enter_hours: 'Enter hours',
  location_info: 'Location info',
  after_setting_the_location: 'After setting the location, users can click  the address on the card to open it on Google Maps.',
  enter_address: 'Enter address',
  click_on_map: 'Click on map to choose location',
  tag: 'Tag',
  tag1: 'Tag1',
  tag2: 'Tag2',
  tag3: 'Tag3',
  enter_tag: 'Enter tag text',
  crop: 'Crop',
  personalized_messages: 'Personalized messages',
  choose_which_data_fields: 'Choose which data fields to use when sending personalized messages to each recipient.',
  personalized_messages_1: 'Personalized messages 1',
  personalized_messages_2: 'Personalized messages 2',
  personalized_messages_3: 'Personalized messages 3',
  personalized_messages_4: 'Personalized messages 4',
  personalized_messages_5: 'Personalized messages 5',
  enter_personalized_data_label: 'Enter personalized data label',
  select_data_to_display: 'Select data to display',
  define_placeholder_text: 'Define placeholder text',

  please_enter_template_name: 'Please enter template name.',
  please_enter_a_header: 'Please enter a header.',
  please_enter_a_label: 'Please enter a label.',
  please_enter_a_price: 'Please enter a price.',
  please_enter_a_url: 'Please enter a URL.',
  please_enter_an_address: 'Please enter an address.',

  use: 'Use',
  datepicker,
  customerInsight,

  // Segment Template

  system_template: 'Template Library',
  add_template: 'Add Template',
  system: 'System',
  template: 'Template',
  my_template: 'My Template',
  show: 'Show',
  segment_name: 'Segment Name',
  create_segment: 'Create Segment',
  import_segment: 'Import Segment',
  export_segment: 'Export Segment',
  delete: 'Delete',
  edit: 'Edit',
  duplicate: 'Duplicate',
  search: 'Search',
  filter: 'Filter',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  created_date: 'Created Date',
  updated_date: 'Updated Date',
  no_data: 'No Data',
  delete_template: 'Delete template “{any}” ',
  confirm_delete: 'Are you sure you want to delete this template?',
  total: 'Total',
  items: 'Items',
  selected: 'Selected',
  segment_detail: 'Segment Detail',
  created_by: 'Created By',
  last_updated_by: 'Last Updated By',
  back: 'Back',
  save: 'Save',
  save_success: 'Save Successful',
  delete_success: 'Delete Successful',
  segment_condition: 'Segment Condition',
  add_condition: 'Add Condition',
  no_condition: 'No Condition',
  preview: 'Preview',
  total_customer: 'Total Customers',
  apply: 'Apply',
  select_template: 'Select Template',
  template_name: 'Template Name',
  please_input_template_name: 'Please input template name',
  please_input_description: 'Please input description',
  template_type: 'Template Type',
  group_type: 'Group Type',
  category_type: 'Category Type',
  use_template_create_segment: 'Would you like to use this template to create an audience group?',
  clear_data_modal: 'Clear all data',
  des_clear_data_modal: 'Updating the segment conditions will clear your previous settings.',
  default_button_template: 'Reset to default',
  des_default_button_template: 'This will clear all configured conditions and restore the original template settings.',
  please_input: 'Please fill in this field',
  please_input_number: 'Please enter a valid number',
  please_input_boolean: 'Please enter 0 or 1 only',
  default: 'Default',
  create_template: 'Create Template',
  save_template: 'Save as Template',
};
